const results = [
  {
    icon: 'ri-search-eye-line',
    title: 'Фундаментальный анализ',
    text: 'Исследование вашей ЦА и разведка стратегий конкурентов.',
    accent: 'Research',
  },
  {
    icon: 'ri-layout-masonry-line',
    title: 'SMM-архитектура',
    text: 'Настроенные и упакованные сообщества (Telegram, ВКонтакте, Instagram/Facebook*, Дзен, Tenchat).',
    footnote: true,
    accent: 'Setup',
  },
  {
    icon: 'ri-group-2-line',
    title: 'Лояльное комьюнити',
    text: 'Появление «адвокатов бренда», которые защищают ваши интересы и покупают повторно.',
    accent: 'Community',
  },
  {
    icon: 'ri-arrow-up-circle-line',
    title: 'Стабильный рост',
    text: 'Увеличение числа квалифицированных лидов и продаж из социальных сетей более чем на 10%.',
    accent: '+10%',
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: 'Прозрачность',
    text: 'Отлаженная аналитика и отчётность по контенту и пабликам.',
    accent: 'Analytics',
  },
];

export default function SMMResult() {
  return (
    <section id="smm-result" className="py-12 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#C5A880]/15 border border-[#C5A880]/30 mb-5">
            <i className="ri-trophy-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Результаты
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Что вы получите в результате
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full"></div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {results.map((item, i) => (
            <div
              key={i}
              className={`group rounded-2xl p-5 sm:p-8 border transition-all duration-300 hover:border-[#C5A880]/40 ${i === 3 ? 'bg-[#1A2B4C] border-[#1A2B4C] text-white' : 'bg-[#F9F5EF] border-gray-100'}`}
            >
              <div className="flex items-start gap-4">
                <div className={`flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center ${i === 3 ? 'bg-[#C5A880]/30' : 'bg-[#1A2B4C] group-hover:bg-[#C5A880]'} transition-colors duration-300`}>
                  <i className={`${item.icon} text-base sm:text-xl ${i === 3 ? 'text-[#C5A880]' : 'text-white'}`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <h3 className={`text-sm sm:text-base font-bold font-['Playfair_Display'] leading-snug ${i === 3 ? 'text-white' : 'text-[#1A2B4C]'}`}>
                      {item.title}
                    </h3>
                    <span className={`text-xs font-semibold px-2 py-0.5 rounded-full font-['Montserrat'] whitespace-nowrap ${i === 3 ? 'bg-[#C5A880]/30 text-[#FFE0A8]' : 'text-[#C5A880] bg-[#C5A880]/10'}`}>
                      {item.accent}
                    </span>
                  </div>
                  <p className={`text-xs sm:text-sm leading-relaxed font-['Montserrat'] text-justify ${i === 3 ? 'text-white/75' : 'text-gray-600'}`}>
                    {item.text}
                  </p>
                  {item.footnote && (
                    <p className="text-[10px] text-gray-400 font-['Montserrat'] mt-2 leading-relaxed">
                      *Продукт компании Meta (признана экстремистской и запрещена на территории РФ)
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}